import React from "react"
import styled from "styled-components"
import { getCategorySettings } from "../../utils/constants"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"

export const CategoryThumbnail: React.FC<{
  height?: number
  width?: number
  mobileHeight?: number
  mobileWidth?: number
  categoryDatabaseId?: number
  featureImageUrl?: string
  className?: string
  gatsbyImage?: IGatsbyImageData
}> = ({
  height,
  width,
  mobileHeight,
  mobileWidth,
  categoryDatabaseId,
  featureImageUrl,
  className = `thumbnail ${featureImageUrl}`,
  gatsbyImage,
}) => {
  const categorySettings = getCategorySettings(categoryDatabaseId)

  return (
    <Container
      width={width}
      height={height}
      mobileWidth={mobileWidth}
      mobileHeight={mobileHeight}
    >
      {gatsbyImage && (
        <GatsbyImage image={gatsbyImage} alt="" className={className} />
      )}
      {!gatsbyImage && (
        <PostCategoryThumbnail
          className={className}
          src={categorySettings?.thumbnail}
          width={width}
          height={height}
          mobileWidth={mobileWidth}
          mobileHeight={mobileHeight}
        />
      )}
    </Container>
  )
}
const Container = styled.div<{
  height?: number
  width?: number
  mobileHeight?: number
  mobileWidth?: number
}>`
  height: ${props => (props.height ? `${props.height}px` : "auto")};
  max-height: ${props => (props.height ? `${props.height}px` : "auto")};
  width: ${props => (props.width ? `${props.width}px` : "100%")};
  max-width: ${props => (props.width ? `${props.width}px` : "100%")};
  overflow: hidden;
  @media (max-width: 767px) {
    height: ${props =>
      props.mobileHeight ? `${props.mobileHeight}px` : "auto"};
    max-height: ${props =>
      props.mobileHeight ? `${props.mobileHeight}px` : "auto"};
    width: ${props => (props.mobileWidth ? `${props.mobileWidth}px` : "100%")};
    max-width: ${props =>
      props.mobileWidth ? `${props.mobileWidth}px` : "100%"};
  }
`
const PostCategoryThumbnail = styled.img<{
  height?: number
  width?: number
  mobileHeight?: number
  mobileWidth?: number
}>`
  height: ${props => (props.height ? `${props.height}px` : "auto")};
  width: ${props => (props.width ? `${props.width}px` : "100%")};
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  object-fit: cover;
  object-position: left top;
  overflow-clip-margin: content-box;
  overflow: clip;
  @media (max-width: 767px) {
    height: ${props =>
      props.mobileHeight ? `${props.mobileHeight}px` : "auto"};
    width: ${props => (props.mobileWidth ? `${props.mobileWidth}px` : "100%")};
  }
`
